import { isDateInRange } from '@libs/core';

import type { Entry } from '../types';

type LocalizedField = {
    'en-US': string;
};

function isLocalizedField(field: unknown): boolean {
    return typeof field === 'object' && !!field && 'en-US' in field;
}

function getLocalizedFieldValue(field: LocalizedField): string {
    return field['en-US'] ?? '';
}

export function filterEntryByDate(entry: Entry | null, previewDate: Date): Entry | null {
    if (entry?.metadata && entry?.sys && entry?.fields) {
        Object.keys(entry.fields).forEach((entryFieldKey: string) => {
            let entryField = entry.fields?.[entryFieldKey];

            if (Array.isArray(entryField)) {
                entryField = (entryField as Entry[]).filter(subEntry => {
                    return filterEntryByDate(subEntry, previewDate);
                });
            } else if (typeof entryField === 'object' && entryField !== null) {
                entryField = filterEntryByDate(entryField as Entry, previewDate);
            }

            if (entry.fields) {
                entry.fields[entryFieldKey] = entryField ?? {};
            }
        });
    }

    const startDateString = isLocalizedField(entry?.fields?.startDate)
        ? getLocalizedFieldValue(entry?.fields?.startDate as LocalizedField)
        : ((entry?.fields?.startDate as string) ?? '');
    const endDateString = isLocalizedField(entry?.fields?.endDate)
        ? getLocalizedFieldValue(entry?.fields?.endDate as LocalizedField)
        : (entry?.fields?.endDate as string);

    return isDateInRange(previewDate, [startDateString, endDateString]) ? entry : null;
}

export function filterEntriesByDate(entries: (Entry | null)[], previewDate: Date): Entry[] {
    return entries.filter((entry): entry is Entry => filterEntryByDate(entry, previewDate) !== null);
}
